import { render, staticRenderFns } from "./DayTabs.vue?vue&type=template&id=0da93b4e&scoped=true&"
import script from "./DayTabs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DayTabs.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DayTabs.vue?vue&type=style&index=0&id=0da93b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da93b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da93b4e')) {
      api.createRecord('0da93b4e', component.options)
    } else {
      api.reload('0da93b4e', component.options)
    }
    module.hot.accept("./DayTabs.vue?vue&type=template&id=0da93b4e&scoped=true&", function () {
      api.rerender('0da93b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/DayTabs.vue"
export default component.exports